<i18n>
{
"en": {
  "STUDENTS": "Students",
  "MANAGESTUDENT": "Manage Student",
  "NAME": "Name",
  "STATUS": "Status",
  "GRADE": "Grade",
  "CLASS": "Class",
  "ADDNEWSTUDENT": "Add New Student",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "IDCARD": "ID Card",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME": "Father Name",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)",
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "NATIONALITY": "Nationality",
  "DATEOFBIRTH": "Date of Birth",
  "STUDENTSCHOOLID": "Student School ID",
  "ATTENDANCETAGID": "Attendance Tag ID",
  "RELATION": "Relation",
  "PRIMARYCONTACT": "Primary Contact",
  "SEARCHADDRESS": "Search Address",
  "LAT": "Latitude",
  "LNG": "Longitude",
  "SET": "Set",
  "HOUSENUMBER": "House Number",
  "STREETNUMBER": "Street Number",
  "AREA": "Area",
  "ZONE": "Zone",
  "SECTOR": "Sector",
  "CITY": "City",
  "STATE": "State",
  "ZIPCODE": "Zip Code / Postal Code",
  "STUDENTADDRESSLOCATION": "Student Address Location",
  "NORELATIVESHASBEENADDED": "No relatives has been added",
  "STREETADDRESS": "Street Address",
  "LOADING": "Loading...",
  "SAVING": "Saving..",
  "GENDER": "Gender",
  "MALE": "Male",
  "FEMALE": "Female",
  "SAVEIMAGE": "Save Image",
  "UPLOADIMAGE": "Upload Image",
  "PICKADATE": "Pick a date",
  "SELECTNATIONALITY": "Select Nationality",
  "SELECTGRADE": "Select Grade",
  "SELECTCLASS": "Select Class",
  "CLICKONSCAN": "Click on scan",
  "SCAN": "Scan",
  "ADDRESS": "Address",
  "CONFIRM": "Confirm",
  "GUARDIANS": "Guardians",
  "SEARCHGUARDIANNAME": "Search guardian name",
  "COORDINATES": "Coordinates",
  "MESSAGES": "Messages",
  "ROUTES": "Routes",
  "ABSENCES": "Absences",
  "ERROR": "Error",
  "CLOSE": "Close",
  "BASEBETWEEN": "Base between 2 and 36",
  "PERSONALREADYINTHELIST": "Person already in the list",
  "STUDENTCANNOTHAVEFATHERSORMOTHERS": "Student can not have 2 fathers or mothers",
  "OK": "Ok",
  "AVATARPICTUREMUSTBEJPGFORMAT": "Avatar picture must be JPG format!",
  "AVATARPICTURESIZECANNOTEXCEED": "Avatar picture size can not exceed 2MB!",
  "ISREQUIRED": "is required.",
  "ISREQUIREDLATLNG": "is required latitude & longitude.",
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",
  "ISNOTAVALIDFORMAT": "is not a valid format. Only letters, spaces and dashes are allowed.",
  "ISNOTAVALIDARABICFORMAT": "is not a valid arabic format.",
  "MUSTBEDECIMAL": "must be decimal.",
  "MUSTBENUMERIC": "must be numeric.",
  "ALREADYEXISTED": "already existed.",
  "MONITOR": "Monitor",
  "FATHER": "Father",
  "MOTHER": "Mother",
  "GUARDIAN": "Guardian",  
  "FILEISTOOLARGERMAXFILEIS": "File is too larger max file is {size}",
  "BUSNUMBER": "Bus Number",
  "ROUTES": "Routes",
  "NAME": "Name",
  "DRIVER": "Driver",
  "SUPERVISOR": "Supervisor",
  "EDITROUTE": "Edit Route",
  "ACTIVITIES": "Activities",
  "ACTIVITYNAME": "Activity Name",
  "ADDACTIVITY": "Add Activity",
  "EDITACTIVITY": "Edit Activity",
  "DELETEACTIVITY": "Delete Activity",
  "SELECTACTIVITY": "Select Activity",
  "SEEMSTOIDENTICAL": "Seems that location is identical to center location."
},
"ar": {
  "STUDENTS": "الطلاب",
  "MANAGESTUDENT": "ادارة ",
  "NAME": "الإسم",
  "STATUS": "الحالة",
  "GRADE": "الدرجة",
  "CLASS": "الصف",
  "ADDNEWSTUDENT": "اضافة طالب جديد",
  "FIRSTNAME": "الإسم الأول",
  "LASTNAME": "اسم العائلة",
  "IDCARD": "بطاقة التعريف",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل",
  "FIRSTNAME(ARABIC)": "الإسم الأول (عربي)", 
  "FATHERNAME": "اسم الاب",
  "FATHERNAME(ARABIC)": " إسم الأب (عربي)",
  "LASTNAME(ARABIC)": " إسم العائلة (عربي)",
  "NATIONALITY": "الجنسية",
  "DATEOFBIRTH": "تاريخ الميلاد",
  "STUDENTSCHOOLID": "رقم الطالب المدرسي",
  "ATTENDANCETAGID": "رقم البطاقة الاكترونية",
  "RELATION": "الصلة",
  "PRIMARYCONTACT": "ولي الامر الرئيسي",
  "SEARCHADDRESS": "بحث العنوان",
  "LAT": "الخط العامودي",
  "LNG": "الخط الطولي",
  "SET": "تثبيت",
  "HOUSENUMBER": "رقم المنزل",
  "STREETNUMBER": "رقم الشارع",
  "AREA": "النطقة",
  "ZONE": "الحوض",
  "SECTOR": "القسم",
  "CITY": "المدينة",
  "STATE": "الامارة",
  "ZIPCODE": "الرمز البريدي",
  "STUDENTADDRESSLOCATION": " موقع عنوان الطالب",
  "NORELATIVESHASBEENADDED": "ولم يضف أي أقارب",
  "STREETADDRESS": "عنوان الشارع",
  "LOADING": "جار التحميل...",
  "SAVING": "احتفاظ",
  "GENDER": "جنس",
  "MALE": "ذكر",
  "FEMALE": "أنثى",
  "SAVEIMAGE": "احفظ الصورة",
  "UPLOADIMAGE": "تحميل الصور",
  "PICKADATE": "اختر تاريخا",
  "SELECTNATIONALITY": "اختيار الجنسية",
  "SELECTGRADE": "حدد الصف",
  "SELECTCLASS": "حدد الدرجة",
  "CLICKONSCAN": "انقر على المسح الضوئي",
  "SCAN": "تفحص",
  "ADDRESS": "العنوان",
  "CONFIRM": "تأكد",
  "GUARDIANS": "أولياء الأمور",
  "SEARCHGUARDIANNAME": "ابحث عن إسم الولي",
  "COORDINATES": "إحداثيات",
  "MESSAGES": "رسائل",
  "ROUTES": "طرق",
  "ABSENCES": "الغياب",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "BASEBETWEEN": "قاعدة بين 2 و36",
  "PERSONALREADYINTHELIST": "شخص موجود بالفعل في القائمة",
  "STUDENTCANNOTHAVEFATHERSORMOTHERS": "الطالب لا يمكن أن يكون له أبوين أو 2 أمهات",
  "OK": "حسنا",
  "AVATARPICTUREMUSTBEJPGFORMAT": " JPG يجب أن تكون الصورة الرمزية على شكل ",
  "AVATARPICTURESIZECANNOTEXCEED": "2M حجم الصورة الرمزية لا يمكن أن يتجاوز",
  "ISREQUIRED": ".مطلوب",
  "MUSTBEATLEASTCHARACTERSINLENGTH": ".يجب أن تكون على الأقل {len} حرفا",
  "CANNOTEXCEEDCHARACTERSINLENGTH": ".لا يمكن أن يتجاوز {len} حرفا",
  "ISNOTAVALIDFORMAT": ".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات",
  "ISNOTAVALIDARABICFORMAT": ".ليست صيغة عربية صحيحة",
  "MUSTBEDECIMAL": "يجب أن يكون عشري",
  "MUSTBENUMERIC": "يجب أن تكون رقمية",
  "ALREADYEXISTED": ".موجودة بالفعل",
  "MONITOR": "مراقب",  
  "FATHER": "الاب",
  "MOTHER": "الام",
  "GUARDIAN": "ولي الامر",
  "FILEISTOOLARGERMAXFILEIS": "الملف أكبر من الحد الأقصى للملف {size}",
  "ROUTES": "خطوط السير",
  "BUSNUMBER": "رقم الحافلة",
  "NAME": "الاسم",
  "DRIVER": "السائق",
  "SUPERVISOR": "المشرفة",
  "EDITBUS": "تحرير الحافلة",
  "ACTIVITIES": "أنشطة",
  "ACTIVITYNAME": "اسم النشاط",
  "ADDACTIVITY": "إضافة نشاط",
  "EDITACTIVITY": "تحرير نشاط",
  "DELETEACTIVITY": "حذف نشاط",
  "SELECTACTIVITY": "اختيار نشاط",
  "SEEMSTOIDENTICAL": ".يبدو أن الموقع مطابق لموقع المدرسة",
  "ISREQUIREDLATLNG": ".مطلوب خطوط الطول والعرض",
  "EDITROUTE": "تحرير خط السير"
}
}
</i18n>
<template>
  <div class="form" id="studentManage"  v-loading="loading" :element-loading-text="$t('LOADING')">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
    <wi-save slot="header" :form="['mainForm', 'addressForm']" :title="$t('MANAGESTUDENT')" :data="{student: this.student, guardians: this.guardians, address: this.address}"></wi-save>
    <el-row>
      <el-col :span="10">
        <el-tabs class="formTab" type="border-card" v-bind:style="{ height: cardHeight + 'px' }">
        <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar"  v-bind:style="{ height: cardHeight + 'px' }">
          <el-form ref="mainForm" :model="student" label-width="120px" label-position="top">

            <el-row :gutter="20">
              <el-col :span="12">

               <wi-upload :person="student"></wi-upload>   
 
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('GENDER')" prop="Gender" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change'}">
                  <el-radio-group  size="small" v-model="student.Gender">
                    <el-radio-button label="Male">{{$t('MALE')}}</el-radio-button>
                    <el-radio-button label="Female">{{$t('FEMALE')}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME')" prop="FirstName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="student.FirstName_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME(ARABIC)')" prop="FirstName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="student.FirstName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME')" prop="MiddleName" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="student.MiddleName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME(ARABIC)')" prop="MiddleName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="student.MiddleName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME')" prop="LastName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="student.LastName_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME(ARABIC)')" prop="LastName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="student.LastName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">

              <el-col :span="12">
                <el-form-item :label="$t('DATEOFBIRTH')" prop="DOB" :rules="{type: 'date', required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
                  <el-date-picker type="date" :placeholder="$t('PICKADATE')" :picker-options="pickerOption" :default-value="defaultDate" :format="date_format" v-model="student.DOB" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('NATIONALITY')" prop="Nationality" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
                  <el-select v-model="student.Nationality" :placeholder="$t('SELECTNATIONALITY')" filterable>
                     <el-option :key="key" v-for="(value, key) in $countries" :label="value" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>

            <el-row :gutter="20">

              <el-col :span="12">
                <el-form-item :label="$t('GRADE')" prop="Grade" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
                  <el-select v-model="Grade" @change="setGrade" value-key="GradeID" :placeholder="$t('SELECTGRADE')">
              <el-option
                :key="index" v-for="(item, index) in grades"
                :label="item.Name"
                :value="item">
              </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('CLASS')" prop="Class" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
                  <el-select :disabled="student.Grade==null" v-model="student.Class" :placeholder="$t('SELECTCLASS')">
            <el-option
                :key="index" v-for="(item, index) in Grade.Classes"
                :label="item"
                :value="item">
              </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('STUDENTSCHOOLID')" prop="ExternalStudentID" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validate: true, message: $t('STUDENTSCHOOLID') + ' ' + $t('ALREADYEXISTED')},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:16, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 16}), trigger:'blur'}]">
                  <el-input  v-model="student.ExternalStudentID"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('ATTENDANCETAGID')">
                  <el-input :placeholder="$t('CLICKONSCAN')" v-model="student.AssignedTagID">
                    <el-button slot="append" @click="showScanModal(student)"><i class="fa fa-wifi"></i> {{$t('SCAN')}}</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
          </VuePerfectScrollbar>
        </el-tabs>
  </el-col>
      <el-col :span="14">
        <el-tabs  @tab-click="getTabData" class="formTab" type="border-card"  style="overflow: hidden"  v-bind:style="{ height: cardHeight + 'px' }">
          <el-tab-pane :label="$t('ADDRESS')">
            <VuePerfectScrollbar  ref="addressBar"  v-bind:style="{ height: cardHeight - 42 + 'px' }">
            <el-form  ref="addressForm" :model="address" label-width="120px" label-position="top">
              <el-row class="googleMapV"> 
                  <div id="student-gmap" style="width: 100%; height: 200px"></div>
                  <input type="text" :placeholder="$t('SEARCHADDRESS')"  id="location" class="el-input__inner" style="padding: 25px 10px;" autocomplete="off" />
                </el-row>
                <div style="margin: 15px;">
                  <el-row>
                    <el-form-item :label="$t('COORDINATES')" prop="address" :rules="{validator: valCoordinates, required: true, trigger: 'blur'}">
                      <el-col :span="8">
                        <el-input type="number" v-model.number="address.Lat" @change="positionSet = false">
                          <template slot="prepend">{{$t('LAT')}}</template>
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="8">
                        <el-input type="number" v-model.number="address.Lng" @change="positionSet = false">
                          <template slot="prepend">{{$t('LNG')}}</template>
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="6">
                        <el-button @click="setPosition()" :disabled="positionSet">{{$t('CONFIRM')}}</el-button>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('HOUSENUMBER')" prop="HouseNumber" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'blur'}">
                        <el-input v-model="address.HouseNumber"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('STREETADDRESS')">
                        <el-input v-model="address.Address"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('AREA')">
                        <el-input v-model="address.Area"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('ZONE')">
                        <el-input v-model="address.Zone"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('SECTOR')">
                        <el-input v-model="address.Sector"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CITY')" prop="City" :rules="[{required:true, message:$t('ISREQUIRED'), trigger: 'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:34, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 34}), trigger:'blur'}]">
                        <el-input v-model="address.City"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('STATE')" prop="State" :rules="[{required:true, message:$t('ISREQUIRED'), trigger: 'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:34, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 34}), trigger:'blur'}]">
                        <el-input v-model="address.State"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('ZIPCODE')" prop="ZipCode" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'blur'}">
                        <el-input v-model="address.ZipCode"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </VuePerfectScrollbar>
          </el-tab-pane>
          <el-tab-pane :label="$t('GUARDIANS')">
            <el-row style="padding:20px; padding-bottom:0">
            <el-autocomplete
              v-model="guardian"
              :fetch-suggestions="querySearch"
              :placeholder="$t('SEARCHGUARDIANNAME')"
              @select="addGuardian"
              icon="search"
            ></el-autocomplete>
            </el-row>
           <el-row class="tab-table-margin" style="margin-top:20px">
            <el-table
              :data="listGuardians"
              highlight-current-row
              :height="cardHeight-118"
              stripe
              style="width: 100%">
              <el-table-column
                :label="$t('NAME')"
                align="left"
              >
                <template slot-scope="scope">
                  <img :src="getAsset(scope.row.ImagePath, 'guardian')" alt="" class="img-circle" style="width: 50px; float: left;">
                     {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR}) + $t('')}}
                </template>              
              </el-table-column>
              <el-table-column
                :label="$t('RELATION')"
                align="center">
                <template slot-scope="scope">
                  {{$t(scope.row.Relation)}}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('PRIMARYCONTACT')"
                align="center">
                <template slot-scope="scope">
                <el-button type="text" @click="checkPrimary(scope.row)">
                <span class="el-radio__input" v-bind:class="{'is-checked':scope.row.IsPrimary}">
                <span class="el-radio__inner"></span>
                </span>
                </el-button>
          </template>
              </el-table-column>

              <el-table-column
                align="center">
                <template slot-scope="scope">
                  <i v-show="scope.row.length>1 && !scope.row.IsMain" @click="scope.row.deleted=!scope.row.deleted" class="fa fa-2x" v-bind:class="scope.row.deleted ? 'fa-undo' : 'fa-remove'"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          </el-tab-pane>
          <el-tab-pane name="route" :label="$t('ROUTES')" v-if="student.StudentID!=null">
          <el-row class="tab-table-margin">
               <el-table
        v-loading="loadingRoutes" 
        :element-loading-text="$t('LOADING')"
        :data="routes"
        highlight-current-row
        :height="cardHeight-118"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('NAME')"
          show-overflow-tooltip
          min-width="130"
          class="left"
        >

          <template slot-scope="scope">
            <el-tag style="display:block; text-align:center;"  v-bind:style="'background-color:' + scope.row.RouteColor">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})" style="color:#fff; padding:0">{{scope.row.TourName}}</el-button>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="BusNumber"
          :label="$t('BUSNUMBER')"
          min-width="100"
          align="left"
          sortable>
        </el-table-column>


        <el-table-column
          :label="$t('DRIVER')"
          min-width="130"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.DriverPhoto, 'driver')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.DriverFullName_EN, NameAR: scope.row.DriverFullName_AR})}}            
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('SUPERVISOR')"
          min-width="130"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.MonitorPhoto, 'supervisor')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.MonitorFullName_EN, NameAR: scope.row.MonitorFullName_AR})}}
          </template>
        </el-table-column>

        <el-table-column
          label=""
          align="right"
          min-width="40"
          class="actions">

          <template slot-scope="scope">
            <el-tooltip :content="$t('EDITROUTE')" placement="top">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})"><i class="fa fa-pencil"></i></el-button>
            </el-tooltip>            
          </template>
        </el-table-column>
      </el-table>
          </el-row>
          </el-tab-pane>
    <el-tab-pane name="activity" :label="$t('ACTIVITIES')" :element-loading-text="$t('LOADING')"   
    v-loading="loadingActivities" >
     <el-form  label-width="120px" label-position="top" style="padding:15px">
         <el-row :gutter="20" style="margin-bottom:10px">
          <el-col :span="12">
   <el-select v-model="Activity" value-key="ID" :placeholder="$t('SELECTACTIVITY')">
    <el-option
         v-if="!activities[item.ID]"
      :key="index" v-for="(item, index) in activityList"
      :label="item.Name"
      :value="item">
    </el-option>
  </el-select>
   </el-col>
   <el-col :span="12">
  <el-button :disabled="Activity==null || savingActivity" value-key="ID" @click="addActivity">
  <i class="fa fa-plus" v-show="!savingActivity"></i> {{savingActivity ? $t('SAVING') : $t('ADDACTIVITY')}}
  </el-button>
     </el-col> 
        </el-row>

   </el-form>

<el-row class="tab-table-margin">
    <el-table
:data="listActivities"

    :height="cardHeight-118"
    style="width: 100%;">

    <el-table-column
      :label="$t('ACTIVITYNAME')"
      prop="Name">
    </el-table-column>

      <el-table-column align="right">
      <template slot-scope="props">
      <el-tooltip :content="$t('DELETEACTIVITY')" placement="top">
        <el-button type="text" @click="deleteActivity(props.row.ActivityID)"><i class="fa fa-remove"></i></el-button>
      </el-tooltip>        
      </template>
    </el-table-column>
 
  </el-table>
</el-row>
</el-tab-pane>
          <el-tab-pane :label="$t('ABSENCES')"  v-if="false">{{$t('ABSENCES')}}</el-tab-pane>
          <el-tab-pane :label="$t('MESSAGES')"  v-if="false">{{$t('MESSAGES')}}</el-tab-pane>
        </el-tabs>
      </el-col>
  </el-row>


      </el-card>
<el-tag-dialog :callScan.sync="callScan" :student="student"></el-tag-dialog>
  <el-dialog
  :title="$t('ERROR')"
  v-model="error"
  size="tiny">

  <div class="el-alert el-alert--error">
    <i class="el-alert__icon el-icon-circle-cross is-big"></i>
    <div class="el-alert__content">
      <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message" v-html="printError(messageError)"></span>
      </div>
   </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import WiUpload from '@/components/dialogs/Upload'
  import WiSave from '@/components/dialogs/Save'
  import TagDialog from '@/components/dialogs/Tag'
  export default {
    components: {VuePerfectScrollbar, 'el-tag-dialog': TagDialog, 'wi-upload': WiUpload, 'wi-save': WiSave},
    data () {
      return {
        student: {StudentID: null, Gender: null, Grade: null, Class: null, AssignedTagID: null, Nationality: null, DOB: null, ImagePath: null},
        loading: false,
        address: {Lng: null, Lat: null},
        grades: [],
        routes: [],
        activities: {},
        activityList: [],
        exludeActivities: [],
        Activity: null,
        Grade: {},
        school: {},
        guardians: [],
        guardian: null,
        activeIndex: '',
        dialogVisible: false,
        dialogImageUrl: '',
        cardHeight: 0,
        cardWidth: 0,
        center: {lat: 0, lng: 0},
        marker: {lat: 0, lng: 0, icon: {url: require('../../assets/img/map/student-marker.png')}},
        Location: null,
        country: null,
        timeout: null,
        error: false,
        callScan: false,
        findTag: false,
        loadingRoutes: false,
        loadingActivities: false,
        savingActivity: false,
        date_format: 'dd/MM/yyyy',
        maps: null,
        map: null,
        autoSource: null,
        changedPrimary: false,
        positionSet: true,
        studentMarker: null,
        message: null,
        defaultDate: Date.now() - (5 * 1000 * 60 * 60 * 24 * 365),
        pickerOption: {
          disabledDate (time) {
            return time.getTime() >= Date.now() - (5 * 1000 * 60 * 60 * 24 * 365)
          }
        }
      }
    },
    computed: {
      listGuardians () {
        return this.guardians
      },
      listActivities () {
        return Object.values(this.activities)
      }
    },
    mounted () {
      this.switchLanguage()
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.country = userData.school_location.country
      this.school = this.center = {lat: userData.school_location.Lat, lng: userData.school_location.Lng}
      this.marker.lat = this.school.Lat
      this.marker.lng = this.school.Lng
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.cardWidth = window.innerWidth - this.$el.offsetWidth
      this.getGrades()
      let self = this
      this.$google.then(function (Maps) {
        let position = new Maps.LatLng(self.center)
        self.maps = Maps
        self.map = new Maps.Map(document.getElementById('student-gmap'), {
          center: position,
          zoom: 14
        })
        let marker = new Maps.Marker({
          position: position,
          icon: require('../../assets/img/map/school.png')
        })

        self.studentMarker = new Maps.Marker({
          position: position,
          draggable: true,
          animation: Maps.Animation.DROP,
          icon: require('../../assets/img/map/student-marker.png')
        })
        marker.setMap(self.map)
        self.studentMarker.setMap(self.map)
        self.studentMarker.addListener('dragend', self.changePosition)
        self.studentMarker.addListener('click', self.toggleBounce)
        let country = JSON.parse(localStorage.getItem('locale')).country
        let autocomplete = new Maps.places.Autocomplete((document.getElementById('location')), {componentRestrictions: {country: country}})
        Maps.event.addListener(autocomplete, 'place_changed', function () {
          let place = autocomplete.getPlace()
          self.address.Lat = place.geometry.location.lat()
          self.address.Lng = place.geometry.location.lng()
          self.setPosition(true)
        })
      })
      self.getStudent()
    },
    methods: {
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      changePosition (marker) {
        this.address.Lat = marker.latLng.lat()
        this.address.Lng = marker.latLng.lng()
        this.positionSet = false
      },
      toggleBounce () {
        if (this.studentMarker.getAnimation() !== null) return this.studentMarker.setAnimation(null)
        this.studentMarker.setAnimation(this.maps.Animation.BOUNCE)
      },
      showScanModal (student) {
        this.callScan = true
        this.student = student
      },
      valCoordinates (rule, value, callback) {
        let decRegexp = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/
        if (!this.address.Lng || !this.address.Lat) {
          callback(new Error(this.$t('ISREQUIREDLATLNG')))
        } else if (!decRegexp.test(this.address.Lng) || !decRegexp.test(this.address.Lat)) {
          callback(new Error(this.$t('MUSTBEDECIMAL')))
        } else if (parseFloat(this.address.Lng) === this.school.Lng && parseFloat(this.address.Lat) === this.school.Lat) {
          callback(new Error(this.$t('SEEMSTOIDENTICAL')))
        }
        callback()
      },
      imageUploaded (res) {
        if (res.file_name !== undefined) this.student.ImagePath = res.file_name
      },
      findGuardian (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/guardian/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&id=' + this.student.StudentID, {cancelToken: this.autoSource.token})
      },
      querySearch (queryString, cb) {
        let self = this
        if (queryString === null) return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findGuardian(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      getGrades () {
        let self = this
        this.$http.get('/configuration/grade')
          .then(function (response) {
            self.grades = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      setGrade (item) {
        if (this.student.Grade === item) return
        this.student.Grade = item.Name
        this.student.Class = null
      },
      base_convert (number, from, to) {
        if (number === null) return
        if ((from && to) < 2 || (from && to) > 36) return this.$t('BASEBETWEEN')
        return parseInt(number + '', from).toString(to)
      },
      getStudent () {
        let self = this
        if (this.$route.params.id === 'create') return
        this.loading = true
        this.$http.get('/student/' + this.$route.params.id + '').then(function (response) {
          let data = response.data
          self.loading = false
          self.address.Lat = self.school.Lat
          self.address.Lng = self.school.Lng
          if (data.student !== undefined && data.length !== 0) {
            self.student = data.student
            self.student.DOB = self.dateFormat(self.student.DOB)
            self.Grade = self.student.Grade
            self.dialogImageUrl = self.URL + 'upload/' + data.student.ImagePath
            self.address = data.address
            if (data.relatives !== undefined) {
              self.guardians = data.relatives
              for (let guardian in self.guardians) {
                self.guardians[guardian].IsPrimary = false
                if (self.guardians[guardian].IsMain === 1) self.guardians[guardian].IsPrimary = true
              }
            }
          }
          self.setPosition()
        }).catch(function (response) {})
      },
      setPosition (autocomplete = false) {
        let self = this
        this.$refs.addressForm.validateField('address', function (errorMessage) {
          if (errorMessage !== '') return
          let position = new self.maps.LatLng(parseFloat(self.address.Lat), parseFloat(self.address.Lng))
          self.studentMarker.setPosition(position)
          self.map.panTo(self.studentMarker.getPosition())
          self.studentMarker.setMap(self.map)
          self.positionSet = true
          if (!autocomplete && document.getElementById('location').value !== '') document.getElementById('location').value = ''
        })
      },
      checkPrimary (guardian) {
        if (guardian.IsPrimary) return
        let guardians = this.guardians.slice()
        for (let i = 0; i < guardians.length; i++) {
          let IsMain = null
          let IsPrimary = false
          if (guardian.PersonID === guardians[i].PersonID) {
            IsMain = 1
            IsPrimary = true
          }
          guardians[i].IsPrimary = IsPrimary
          guardians[i].IsMain = IsMain
        }
        this.guardians = guardians
      },
      addGuardian (data) {
        let IsMain = 1
        let error = false
        if (this.guardians.length !== 0) {
          for (let guardian in this.guardians) {
            if (this.guardians[guardian].PersonID === data.person.PersonID) {
              error = true
              this.message = this.$t('PERSONALREADYINTHELIST')
            }
            if (this.guardians[guardian].Relation !== 'GUARDIAN' && this.guardians[guardian].Relation === data.person.Relation) {
              error = true
              this.message = this.$t('STUDENTCANNOTHAVEFATHERSORMOTHERS')
            }
            this.status = 'Warning'
          }
          if (error) {
            return this.$alert(this.message, this.$t('ERROR'), {
              confirmButtonText: this.$t('OK'),
              type: 'error'
            })
          }
          IsMain = null
        }
        this.guardian = null
        data.person.IsMain = this.student.StudentID === undefined ? 1 : IsMain
        this.guardians.push(data.person)
      },
      handleAvatarSuccess (res, file) {
        this.student.ImagePath = res.file_name
      },
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error(this.$t('AVATARPICTUREMUSTBEJPGFORMAT'))
        }
        if (!isLt2M) {
          this.$message.error(this.$t('AVATARPICTURESIZECANNOTEXCEED'))
        }
        return isJPG && isLt2M
      },
      updateLocation (marker) {
        this.address.Lat = marker.latLng.lat()
        this.address.Lng = marker.latLng.lng()
      },
      imageError (res) {
        let string = res.split(' ')
        let message = this.$t(string[0], {size: string[1]})
        this.$alert(message, this.$t('ERROR'), {type: 'error', cancelButtonText: this.$t('CLOSE'), showCancelButton: true, showConfirmButton: false}).catch({})
      },
      getRoute () {
        let self = this
        if (self.routes.length !== 0) return
        self.loadingRoutes = true
        this.$http.get('/route/assigned?StudentID=' + self.student.StudentID)
          .then(function (response) {
            self.loadingRoutes = false
            self.routes = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getActivity () {
        let self = this
        if (Object.keys(self.activities).length !== 0) return
        self.loadingActivities = true
        this.$http.get('/student/activity?StudentID=' + self.student.StudentID)
          .then(function (response) {
            self.loadingActivities = false
            self.activities = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getActivities () {
        let self = this
        if (self.activityList.length !== 0) return
        this.$http.get('/configuration/activity')
          .then(function (response) {
            self.activityList = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      addActivity () {
        let self = this
        self.savingActivity = true
        this.$http.post('/student/save_activity', {StudentID: self.student.StudentID, ActivityID: self.Activity.ID})
          .then(function (response) {
            let data = {ActivityID: self.Activity.ID, StudentID: self.student.StudentID, Name: self.Activity.Name}
            Vue.set(self.activities, self.Activity.ID, data)
            self.Activity = null
            self.savingActivity = false
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      deleteActivity (ActivityID) {
        let self = this
        this.$http.post('/student/save_activity', {StudentID: self.student.StudentID, ActivityID: ActivityID, delete: true})
          .then(function (response) {
            self.$delete(self.activities, ActivityID)
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getTabData (tab) {
        switch (tab.name) {
          case 'route':
            this.getRoute()
            break
          case 'activity':
            this.getActivity()
            this.getActivities()
            break
        }
      }
    }
  }
</script>

<style>
 #studentManage .formTab .media{padding:15px}
 #studentManage .googleMapV {margin-bottom: 20px;}
 #studentManage .googleMapV input{border-radius: 0; border-left:0; border-right:0}
 #studentManage .el-tab-pane .VuePerfectScrollbar__wrapper {margin: -15px;}
</style>



// WEBPACK FOOTER //
// StudentManage.vue?5dcf0d02